"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledText = exports.StyledProgressAmount = exports.StyledBarContainer = exports.StyledWrapper = exports.StyledProgressBar = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledProgressBar = styled_components_1.default.div `
  position: relative;
  height: ${({ theme }) => theme.sizes['2xs'].value};
  background-color: ${({ theme }) => theme.colors.colours.overlay['digital-black'][10].value};
  width: 100%;
  border-radius: ${({ theme }) => theme.sizes['4xs'].value};
  overflow: hidden;
  &:before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    background-color: ${({ theme }) => theme.colors.theme.themePrimary.value};
    transition: width 0.25s ease-in-out;
    width: ${({ progress }) => `${progress}%`};
    max-width: 100%;
  }
`;
exports.StyledWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
`;
exports.StyledBarContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
`;
exports.StyledProgressAmount = styled_components_1.default.span `
  margin-left: ${({ theme }) => theme.sizes['2xs'].value};
  font-size: ${({ theme }) => theme.typography.desktop.text.small_bold['font-size'].value};
  line-height: ${({ theme }) => theme.typography.desktop.text.small_bold['line-height'].value};
  font-weight: ${({ theme }) => theme.typography.desktop.text.small_bold['font-weight'].value};
  font-family: ${({ theme }) => theme.typography.desktop.text.small_bold['font-family'].value};
  flex: 0 1 auto;
  min-width: ${({ theme }) => theme.sizes.l.value};
`;
exports.StyledText = styled_components_1.default.span `
  width: 100%;
  text-align: center;
  font-weight: ${({ theme }) => theme.typography.desktop.text.tiny_bold['font-weight'].value};
  font-size: ${({ theme }) => theme.typography.desktop.text.tiny_bold['font-size'].value};
  font-family: ${({ theme }) => theme.typography.desktop.text.tiny_bold['font-family'].value};
  line-height: ${({ theme }) => theme.typography.desktop.text.tiny_bold['line-height'].value};
  margin-top: ${({ theme }) => theme.sizes.xs.value};
  color: ${({ theme }) => theme.colors.colours.support[60].value};
`;
//# sourceMappingURL=ProgressBar.styled.js.map